export abstract class TagFormElement {
  public readonly __className: string;
  public readonly id: string;
  public readonly sortOrder: number;
  public readonly type: string;

  protected constructor(id: string, sortOrder: number, type: string, className: string) {
    this.id = id;
    this.sortOrder = sortOrder;
    this.type = type;
    this.__className = className;
  }
}
